module.exports = {
  buildVersion: "0.1.25",
  buildDate: 1748866266037,
}